import { render, staticRenderFns } from "./panel_wanggu.vue?vue&type=template&id=bc6a833c&scoped=true&"
import script from "./panel_wanggu.vue?vue&type=script&lang=js&"
export * from "./panel_wanggu.vue?vue&type=script&lang=js&"
import style0 from "./panel_wanggu.vue?vue&type=style&index=0&id=bc6a833c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6a833c",
  null
  
)

export default component.exports